module.exports = __webpack_public_path__ + "media/application/images/BV_CER_ISO 9001&ISO 14001(B&W)-6d395b8d6634cbaa1a56b4798c93066c.png";